var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.type)?_c('div',[_c('component',_vm._b({on:{"update":function($event){return _vm.$emit('update', $event)}}},'component',_vm.config,false))],1):_c('div',[_vm._v(" ")])}
var staticRenderFns = []

export { render, staticRenderFns }